import React from "react";
import Select from "react-select";
import {usersConfig} from "../../config/usersConfig";

export const UsersFilter: React.FunctionComponent<any>
    = (props: {handleUserFilterChange: () => void}) => {

    // Invoke when user click to request another page.
    const handleUserFilterChange = (event) => {
        props.handleUserFilterChange(event);
    };
    const optionsMenusFilter = [
        {
            value: usersConfig.usersType.chief,
            label: usersConfig.usersLabels.chief,
            status: usersConfig.chiefStatus.chief
        },
        {
            value: usersConfig.usersType.chiefMedal,
            label: usersConfig.usersLabels.chiefMedal,
            status: usersConfig.chiefStatus.chiefMedal
        },
        {
            value: usersConfig.usersType.clients,
            label: usersConfig.usersLabels.clients,
            status: usersConfig.chiefStatus.clients
        },
    ]
    const formatOptionLabel = ({value, label}) => (
        <div style={{display: 'flex', verticalAlign: 'middle'}}>
            {label}
        </div>
    );
    const customStyles = {
        control: (base, state) => ({
            ...base,
            background: "transparent",
            // match with the menu
            borderRadius: 0,
            // Overwrittes the different states of border
            borderColor: 'transparent',
            // Removes weird border around container
            boxShadow: null,
            "&:hover": {
                // Overwrittes the different states of border
                borderColor: state.isFocused ? "#f5f5f5" : "#fefefe"
            },
            minWidth: 150,
            paddingLeft: 0
        }),
        menu: base => ({
            ...base,
            // override border radius to match the box
            borderRadius: 0,
            // kill the gap
            marginTop: 0
        }),
        menuList: base => ({
            ...base,
            // kill the white space on first and last option
            padding: 0
        })
    };
    return (
        <Select
            options={optionsMenusFilter}
            defaultValue={optionsMenusFilter[0]}
            formatOptionLabel={formatOptionLabel}
            onChange={handleUserFilterChange}
            styles={customStyles}
            isSearchable={false}
        />
    )
}
